import { Component, OnInit, Inject, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { ManikEntityFE } from '../manik-library/ManikEntityFE';
import { ManikEntityService } from '../manik-library/ManikEntityService';

@Component({
  selector: 'manik-smart-button',
  templateUrl: './smart-button.component.html'
})
export class SmartButtonComponent extends ManikEntityFE implements OnInit {
  SBtnForm: FormGroup;
  SectionForm: FormGroup;
  @Input() public SBParams: ISmartButton;
  constructor(private formBuilder: FormBuilder, private _manikEntityService: ManikEntityService, @Inject(DOCUMENT) public document: any,
    public _routeParams: ActivatedRoute) {
    super(document);
    this.SBtnForm = this.formBuilder.group({
      ShowActionButton: ['', Validators.required],
      ActionText: ['', Validators.required],
      NavigateURL: ['', Validators.required],
      IconText: [''],
      BGColor: [''],
      TextColor: [''],
      ButtonLayoutID: ['', Validators.required]
    });
  }

  ngOnInit() {
    this.populateControls();
  }

  populateControls(): void {
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null,
      this.prepareEditHeaders2(this.SBParams.SmartButtonHandle, "SMART.BUTTON", this.SBParams.LGContext, this.SBParams.PortalContext))
      .subscribe(data => {
        this.SBtnForm.patchValue(data.ManikJSon[0].JSon0[0]);
      });
  }
  refreshDataGrid(param: any): void {
  }

  get btnForm() {
    return this.SBtnForm.controls;
  }

  SubmitToDB() {
    let body: any = {};
    body = this.SBtnForm.value;
    body["SmartButtonHandle"] = this.SBParams.SmartButtonHandle;
    let SubmitBody = JSON.stringify({ 'items': [body] });
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", SubmitBody, this.prepareManageHeaders2("E", "SMART.BUTTON", this.SBParams.LGContext, this.SBParams.PortalContext))
      .subscribe(data => {
        let id = data.ManikJSon[0].JSon0;
        if (id != null) {
          this.showNotification('bottom', 'right', 'success', 'Page setting update: Success');
          this.populateControls();
        }
      },
        error => {
          this.showNotification('bottom', 'right', 'danger', 'Page setting update: Failure');
          this.populateControls();
        });
  }
}

export interface ISmartButton {
  SmartButtonHandle: string;
  LGContext: string;
  PortalContext: string;
}
